import { MARKET_LABEL } from "@/lib/markets";
// v77 — Creator 360 access + shared wording. Null (no access) while pending or on a 404.
// v88 — loaded through accessLoader: a failed check is retried, never read as "no access".
import { makeAccess } from "@/lib/accessLoader";

const C360 = makeAccess("c360", "/creator360/access", (d) => d || null);
export const resetCreator360Access = C360.reset;

export function useCreator360Access() {
  const { value, ready } = C360.useAccess();
  return { info: value, enabled: !!value, ready };
}

export const AVENUES = ["yt", "live", "tg", "ig"];
export const AV_NAME = { yt: "YouTube standard videos", live: "YouTube live streams", tg: "Telegram", ig: "Instagram" };
export const AV_SHORT = { yt: "YouTube", live: "Live", tg: "Telegram", ig: "Instagram" };
export const AV_UNKNOWN = {
  yt: "No YouTube data yet.",
  live: "Does not go live (or not measured yet).",
  tg: "No Telegram channel found yet.",
  ig: "No Instagram handle found yet.",
};
export const RATING = {
  strong: { label: "Strong", color: "#39FF14", bars: 3 },
  good: { label: "Good", color: "#FBBF24", bars: 2 },
  weak: { label: "Weak", color: "#F43F5E", bars: 1 },
  unknown: { label: "Not known", color: "#71717A", bars: 0 },
};
export const BOT_NAME = { yt: "Bot check", live: "Live bot check", tg: "Telegram bot check", ig: "Instagram bot check" };
export const BOT_LEVEL = {
  high: { label: "High", color: "#F43F5E", hint: "Most of the audience is likely not real." },
  medium: { label: "Medium", color: "#FB923C", hint: "Part of the audience is likely not real." },
  low: { label: "Low", color: "#A1A1AA", hint: "Mostly fine. One or two small oddities." },
  none: { label: "No sign", color: "#39FF14", hint: "Nothing unusual found." },
  small: { label: "Small audience", color: "#71717A", hint: "Small audience. The bot check starts once the audience grows." },
  not_checked: { label: "Not checked yet", color: "#52525B", hint: "Not checked yet." },
};
export const MARKET = { ...MARKET_LABEL, forex: "Forex" };
export const LAST = {
  week: { label: "This week", color: "#39FF14", hover: "this week" },
  w1: { label: "Over a week ago", color: "#39FF14", hover: "over a week ago" },
  d10: { label: "Over 10 days ago", color: "#FBBF24", hover: "over 10 days ago" },
  w2: { label: "Over 2 weeks ago", color: "#FB923C", hover: "over 2 weeks ago" },
  m1: { label: "Over a month ago", color: "#F43F5E", hover: "over a month ago" },
  unknown: { label: "Not known", color: "#71717A", hover: null },
};

export function lastKey(d) {
  if (d == null) return "unknown";
  return d <= 7 ? "week" : d <= 10 ? "w1" : d <= 14 ? "d10" : d <= 30 ? "w2" : "m1";
}

export function short(n) {
  if (n == null) return "—";
  const f = (v, u) => (v >= 100 ? v.toFixed(0) : v >= 10 ? v.toFixed(1) : v.toFixed(2)).replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "") + u;
  if (n >= 1e6) return f(n / 1e6, "M");
  if (n >= 1e3) return f(n / 1e3, "K");
  return String(n);
}

// "20", "2K", "1.5M" → number; "" → null; anything else → NaN.
export function parseNum(s) {
  const t = String(s || "").trim().replace(/,/g, "").toUpperCase();
  if (!t) return null;
  const m = t.match(/^(\d+(?:\.\d+)?)\s*([KM]?)$/);
  if (!m) return NaN;
  return Math.round(parseFloat(m[1]) * (m[2] === "M" ? 1e6 : m[2] === "K" ? 1e3 : 1));
}

export function rangeText(lo, hi) {
  if (lo != null && hi != null) return `${short(lo)}–${short(hi)}`;
  if (lo != null) return `${short(lo)}+`;
  if (hi != null) return `up to ${short(hi)}`;
  return null;
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export function niceDate(iso) {
  const m = String(iso || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${Number(m[3])} ${MONTHS[Number(m[2]) - 1]} ${m[1]}` : null;
}
